if (!customElements.get('product-swatches')) {
  customElements.define('product-swatches', class ProductSwatches extends HTMLElement {
    constructor() {
      super();

      this.productModelId = this.getAttribute('data-product-model-id');
      this.render();
    }

    async fetchProductData() {
      try {
        const response = await fetch(
          `/collections/all?filter.p.m.product.model_id=${encodeURIComponent(this.productModelId)}&view=swatches.json`
        );

        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }

        const productsObject = await response.json();

        return productsObject.products || [];
      } catch (error) {
        console.error(error);
        return [];
      }
    }

    createSwatch(product, currentTitle) {
      const link = document.createElement('a');

      link.classList.add('product-swatches__option');
      link.setAttribute('data-color-option', product.color_id);
      link.setAttribute('href', product.url);

      link.innerHTML = `<img src="${product.img}" width="80" alt="">`;

      if (currentTitle === product.title) {
        link.classList.add('selected');
      }

      return link;
    }

    createGroup(title, products, currentTitle) {
      const group = document.createElement('div');
      group.classList.add('product-swatches__group');

      const heading = document.createElement('div');
      heading.classList.add('product-swatches__group-title');
      heading.textContent = title;

      const options = document.createElement('div');
      options.classList.add('product-swatches__group-options');

      products.forEach((product) => {
        options.appendChild(this.createSwatch(product, currentTitle));
      });

      group.appendChild(heading);
      group.appendChild(options);

      return group;
    }

    async render() {
      if (!this.productModelId) return;

      const products = await this.fetchProductData();

      const optionsWrapper = this.querySelector(
        '.product-swatches__options-wrapper'
      );

      const currentTitle = this.getAttribute('data-product-title');

      if (!optionsWrapper || !products.length) return;

      const leftProducts = [];
      const rightProducts = [];
      const regularProducts = [];

      products.forEach((product) => {
        const tags = Array.isArray(product.tags)
          ? product.tags.map((tag) => tag.toLowerCase())
          : [];

        if (tags.includes('left')) {
          leftProducts.push(product);
        } else if (tags.includes('right')) {
          rightProducts.push(product);
        } else {
          regularProducts.push(product);
        }
      });

      const hasLeftRightGroups =
        leftProducts.length > 0 || rightProducts.length > 0;

      if (hasLeftRightGroups) {
      optionsWrapper.classList.add('is-grouped');
      }
      /*
       * No left/right products:
       * retain existing behaviour.
       */
      if (!hasLeftRightGroups) {
        products.forEach((product) => {
          optionsWrapper.appendChild(
            this.createSwatch(product, currentTitle)
          );
        });

        return;
      }

      /*
       * Left/right products:
       * render them as separate groups.
       */
      if (leftProducts.length) {
        optionsWrapper.appendChild(
          this.createGroup('Left', leftProducts, currentTitle)
        );
      }

      if (rightProducts.length) {
        optionsWrapper.appendChild(
          this.createGroup('Right', rightProducts, currentTitle)
        );
      }

      /*
       * Safety fallback:
       * if there are untagged products in a grouped model,
       * display them after the groups rather than losing them.
       */
      regularProducts.forEach((product) => {
        optionsWrapper.appendChild(
          this.createSwatch(product, currentTitle)
        );
      });
    }
  });
}